import a from "./index79.js";
const e = typeof URLSearchParams < "u" ? URLSearchParams : a;
export {
  e as default
};
